import { render, staticRenderFns } from "./WarningActionAttendanceModal.vue?vue&type=template&id=460a2582&scoped=true"
import script from "./WarningActionAttendanceModal.vue?vue&type=script&lang=js"
export * from "./WarningActionAttendanceModal.vue?vue&type=script&lang=js"
import style0 from "./WarningActionAttendanceModal.vue?vue&type=style&index=0&id=460a2582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a2582",
  null
  
)

export default component.exports